module.exports = __webpack_public_path__ + "img/round-center.c06dc495.svg";